var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    positionMargin: spacing.xSmall,
    positionPadding: spacing.xSmall,
    positionBackgroundColor: colors.contrasts.grey125125,
    positionZIndex: '3333',
    positionDimension: '2em',
    positionTextColor: colors.contrasts.grey1111,
    positionTextFontSize: typography.fontSizeMedium
  };
};
export default generateComponentTheme;